import React from 'react';

export interface EmptyStateProps {
  icon?: string;
  title: string;
  subtitle?: string;
  primaryAction?: {
    label: string;
    icon?: string;
    onClick: () => void;
  };
  secondaryAction?: {
    label: string;
    onClick: () => void;
  };
  footer?: string;
}

export default function EmptyState({
  icon = 'ri-ghost-line',
  title,
  subtitle,
  primaryAction,
  secondaryAction,
  footer,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-6 text-center">
      {/* Icon area */}
      <div
        className="w-20 h-20 flex items-center justify-center rounded-2xl mb-5"
        style={{ background: 'linear-gradient(135deg, #a78bfa, #7c3aed)' }}
      >
        <i className={`${icon} text-white text-3xl`} />
      </div>

      {/* Title */}
      <h3 className="text-gray-900 font-bold text-base mb-2">{title}</h3>

      {/* Subtitle / description */}
      {subtitle && (
        <p className="text-gray-400 text-sm leading-relaxed mb-6 max-w-[260px]">
          {subtitle}
        </p>
      )}

      {/* Primary action */}
      {primaryAction && (
        <button
          onClick={primaryAction.onClick}
          className="w-full max-w-[260px] py-3 rounded-2xl text-white text-sm font-semibold flex items-center justify-center gap-2 mb-3"
          style={{ background: 'linear-gradient(135deg, #6366f1, #7c3aed)' }}
        >
          {primaryAction.icon && <i className={`${primaryAction.icon} text-lg`} />}
          {primaryAction.label}
        </button>
      )}

      {/* Secondary action */}
      {secondaryAction && (
        <button
          onClick={secondaryAction.onClick}
          className="py-2 px-4 text-gray-500 text-sm font-medium"
        >
          {secondaryAction.label}
        </button>
      )}

      {/* Footer hint */}
      {footer && (
        <p className="text-gray-300 text-xs mt-4">{footer}</p>
      )}
    </div>
  );
}